import styled, {css} from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledUploadManagerDiv = styled.div`
{
  ${() => css`
    height: 100%;
  `}
`;
